import React from 'react';
import { Avatar } from '../Avatar/Avatar';
import { useAuth } from '../../contexts/AuthContext';
import { useUserData } from '../../hooks/useUserData';

interface UserAvatarProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
}

export const UserAvatar: React.FC<UserAvatarProps> = React.memo(({
  className,
  style,
  onClick,
  size = 'medium'
}) => {
  const { user } = useAuth();
  const { userData } = useUserData();
  
  // Estado para manter dados estáveis
  const [stableUser, setStableUser] = React.useState<any>(null);

  // Atualiza stableUser apenas quando há dados válidos
  React.useEffect(() => {
    const currentUser = user || userData;
    if (currentUser && (currentUser.name || currentUser.email)) {
      setStableUser(currentUser);
    }
  }, [user, userData]);

  // Usa dados estáveis ou fallback
  const finalUser = stableUser || user || userData;
  const userName = finalUser?.name || finalUser?.email || "Usuário";
  const userPicture = finalUser?.picture;

  return (
    <Avatar
      name={userName}
      picture={userPicture}
      className={`${className || ''} ${size}`}
      style={style}
      onClick={onClick}
    />
  );
});

UserAvatar.displayName = 'UserAvatar';